import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AnalyticsPaymentsService } from '@core/services/google-analytics/trackers/payments/ga-payments.service';
import { Receipt } from '@features/payments/interfaces/payment.interface';
import { CustomCurrencyPipe } from '@shared/pipes/custom-currency.pipe';

@Component({
  selector: 'app-payment-history-card',
  imports: [DatePipe, CustomCurrencyPipe],
  templateUrl: './payment-history-card.component.html',
  styleUrl: './payment-history-card.component.scss',
})
export class PaymentHistoryCardComponent {
  @Input() receipt!: Receipt;
  @Input() numberOfReceipts?: number;

  constructor(
    private readonly _gAnalyticsPaymentsService: AnalyticsPaymentsService,
  ) {}

  clickDownloadReceipt() {
    this._gAnalyticsPaymentsService.downloadReceipt();
  }
}
